'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _extends = require('@babel/runtime/helpers/extends');
var React = require('react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const HelpCircle = props => /*#__PURE__*/React__default["default"].createElement("svg", _extends__default["default"]({
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React__default["default"].createElement("g", {
  clipPath: "url(#clip0_149_4656)"
}, /*#__PURE__*/React__default["default"].createElement("g", {
  clipPath: "url(#clip1_149_4656)"
}, /*#__PURE__*/React__default["default"].createElement("path", {
  d: "M7.99992 14.6666C11.6818 14.6666 14.6666 11.6818 14.6666 7.99992C14.6666 4.31802 11.6818 1.33325 7.99992 1.33325C4.31802 1.33325 1.33325 4.31802 1.33325 7.99992C1.33325 11.6818 4.31802 14.6666 7.99992 14.6666Z",
  stroke: "#A0A0A0",
  strokeWidth: "1.5",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React__default["default"].createElement("path", {
  d: "M6.06006 5.99989C6.21679 5.55434 6.52616 5.17863 6.93336 4.93931C7.34056 4.7 7.81932 4.61252 8.28484 4.69237C8.75036 4.77222 9.1726 5.01424 9.47678 5.37558C9.78095 5.73691 9.94743 6.19424 9.94672 6.66656C9.94672 7.99989 7.94673 8.66656 7.94673 8.66656",
  stroke: "#A0A0A0",
  strokeWidth: "1.5",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React__default["default"].createElement("path", {
  d: "M8 11.3333H8.0075",
  stroke: "#A0A0A0",
  strokeWidth: "1.5",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))), /*#__PURE__*/React__default["default"].createElement("defs", null, /*#__PURE__*/React__default["default"].createElement("clipPath", {
  id: "clip0_149_4656"
}, /*#__PURE__*/React__default["default"].createElement("path", {
  d: "M0 4C0 1.79086 1.79086 0 4 0H12C14.2091 0 16 1.79086 16 4V12C16 14.2091 14.2091 16 12 16H4C1.79086 16 0 14.2091 0 12V4Z",
  fill: "white"
})), /*#__PURE__*/React__default["default"].createElement("clipPath", {
  id: "clip1_149_4656"
}, /*#__PURE__*/React__default["default"].createElement("rect", {
  width: "16",
  height: "16",
  fill: "white"
}))));

exports["default"] = HelpCircle;
